module.exports = __webpack_public_path__ + "static/media/nb5.82847f0e.jpg";